import './StatusNotice.css';

export type StatusNoticeTone = 'success' | 'pending' | 'error';

interface StatusNoticeProps {
  message: string;
  tone: StatusNoticeTone;
}

export function StatusNotice({ message, tone }: StatusNoticeProps) {
  return (
    <div className={`status-notice status-notice--${tone}`} role="status">
      <svg className="status-notice__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {tone === 'success' ? <path d="m5 12 4 4L19 6" /> : <><circle cx="12" cy="12" r="9" /><path d={tone === 'pending' ? 'M12 7v5l3 2' : 'M12 8v5m0 3h.01'} /></>}
      </svg>
      <span>{message}</span>
    </div>
  );
}
